"use client";

import { useEffect, useRef } from "react";
import styles from "./DocumentationSearch.module.css";

export default function DocumentationSearch() {
  const input = useRef<HTMLInputElement>(null);
  useEffect(() => {
    function focusSearch(event: KeyboardEvent) {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        if (event.defaultPrevented) return;
        event.preventDefault();
        const visible = Array.from(document.querySelectorAll<HTMLInputElement>('input[aria-label="Search all documentation"]')).find((element) => {
          const box = element.getBoundingClientRect();
          return box.width > 0 && box.height > 0 && box.top >= 0 && box.left >= 0 && box.bottom <= innerHeight && box.right <= innerWidth;
        });
        if (visible) visible.focus();
        else window.location.assign("/search");
      }
    }
    document.addEventListener("keydown", focusSearch);
    return () => document.removeEventListener("keydown", focusSearch);
  }, []);

  return (
    <form action="/search" className={styles.search} role="search" aria-label="Site search">
      <input ref={input} aria-label="Search all documentation" type="search" name="q" placeholder="Search docs…" maxLength={200} required />
      <button type="submit">Search</button>
    </form>
  );
}
